import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import Swal from "sweetalert2";

import {
    Container,
    Row
} from "reactstrap"
import axios from "axios"
import { API_URL } from "helpers/app_url";
class CustomTemplates extends Component {
    constructor(props) {
        super(props)
        this.state = {
            templates : []
        }

    }



    componentDidMount() {
        this.fetchTemplates();

    }
    fetchTemplates = () => {
        const authUser = localStorage.getItem("authUser");
        if (!authUser) return;
        const obj = JSON.parse(authUser);
        const token = obj?.resultData?.bearerToken;
        if (!token) return;
        const str = 'Bearer ' + token;
        axios.get(`${API_URL}ProjectEmailTemplate/alltemplates`, {
            params: { agentId: parseInt(localStorage.getItem("userId")) },
            headers: { Authorization: str }
        })
        .then(res => this.setState({ templates: res.data }))
        .catch(err => console.error("Error fetching templates:", err));
    }
    deleteTemplate = (templateId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                const authUser = localStorage.getItem("authUser");
                if (!authUser) return;
    
                const obj = JSON.parse(authUser);
                const token = obj?.resultData?.bearerToken;
                if (!token) return;
    
                const str = 'Bearer ' + token;
    
                axios.delete(`https://rscoreapi.azurewebsites.net/api/ProjectEmailTemplate/${templateId}`, {
                    headers: { Authorization: str }
                })
                .then(() => {
                    this.setState(prevState => ({
                        templates: prevState.templates.filter(template => template.id !== templateId)
                    }));
                    
                    // Show success message
                    Swal.fire("Deleted!", "The template has been deleted.", "success");
                })
                .catch(err => {
                    console.error("Error deleting template:", err);
                    Swal.fire("Error!", "Failed to delete the template.", "error");
                });
            }
        });
    }
    render() {

        //
        return (
            <React.Fragment>

                <div className="page-content project-page-content">
                    <MetaTags>
                        <title>All Templates | Realty Space</title>
                    </MetaTags>
                    <Container fluid>
                        <Row>
                            <Breadcrumbs title={this.props.t("Projects")} breadcrumbItem={this.props.t("Email Templates")} />
                        </Row>
                        <Row>
                        <div className="col-lg-3">
                                <div className="tempData tempData17 card">
                                    <div className="card-body">
                                        <div className="mt-0 card-title">Ad New Custom Template</div>
                                        <p className="card-text"></p>
                                        </div>
                                        <div className="card-footer">
                                            <Link to="/custom-template"  className="previewClass card-link float-left tempLink">Create New</Link>
                                    </div>
                                </div>
                            </div>
                        {
                            this.state.templates
                                .map(template =>
                        <div className="col-lg-3" key={template.id}>
                                <div className="tempData tempData20 card">
                                    <div className="card-body">
                                        <div className="mt-0 card-title">{template.templateTitle}</div>
                                        <p className="card-text"></p>
                                        </div>
                                        <div className="card-footer">
                                            { <Link to={`/pre-construction/email-update/${template.id}`} className="previewClass card-link float-left tempLink">View / Edit</Link>}

                                        <Link to="#" onClick={() => this.deleteTemplate(template.id)} className="previewClass card-link float-end tempLink">Delete</Link>
                                    </div>
                                </div>
                            </div>
                                )}
                           
                        </Row>

                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
CustomTemplates.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,




}
const mapStateToProps = ({ Template }) => (
    {

    })
const mapDispatchToProps = dispatch => ({

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CustomTemplates))
